<template>
  <div>
    <v-row style="margin-left:20px;margin-right:20px;">
      <v-col md="8">
        <v-expansion-panels v-model="panel" multiple>
          <v-expansion-panel >
            <v-expansion-panel-header>
              <h3 style="color:black;">
                <b>ORDER SUMMARY</b>
              </h3>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div v-for="i in prodata" :key="i">
                <hr />

                <v-card-text>
                  <v-row>
                    <v-col md="2">
                      <v-col md="12">
                        <v-card class="jj">
                          <v-img
                            :src="'https://api.inguzsales.in/u/'+i.product.photos[0]"
                            style="width:100%;height:100%;object-fit:cover;"
                          />
                        </v-card>
                      </v-col>

                      <v-row>
                        <v-col md="2">
                          <span class="by">
                            <strong
                              @click="minusCart(i)"
                              style="font-size:26px;padding-left:10px;"
                            >-</strong>
                          </span>
                        </v-col>
                        <v-col md="5" style="padding-left:30px;">
                          <div class="card bu">
                            <input
                              type="text"
                              id="fname"
                              name="fname"
                              size="5"
                              v-model="i.quantity"
                              style="font-size:15px;padding-left:10px;padding-top:3px;"
                            />
                          </div>
                        </v-col>
                        <v-col md="3">
                          <span class="by">
                            <strong @click="UpdateCart(i)" style="font-size:20px;padding:7px;">+</strong>
                          </span>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col md="9" style="padding-top:20px;">
                      <h3 style="color:black;">
                        <strong>{{i.product.productname}}</strong>
                      </h3>
                      <br />
                      <h3 style="color:black;">
                        <strong>{{i.product.description.slice(0,50)}}</strong>
                      </h3>
                      <br />
                      <h3 style="color:black;">
                        <strong>₹ {{i.product.price}}</strong>
                      </h3>
                      <br />
                      <v-layout>
                        <v-flex style="padding-top:50px;">
                          <span>
                            <h3 style="color:black;">
                              <strong>SAVE FOR LATER</strong> &nbsp;&nbsp;
                              <strong @click="RemoveCart">
                                <a style="color:black;">REMOVE</a>
                              </strong>
                            </h3>
                          </span>
                        </v-flex>
                      </v-layout>
                    </v-col>
                  </v-row>
                </v-card-text>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <h3 style="colo:black;">
                <b>DELIVERY ADDRESS</b>
              </h3>
            </v-expansion-panel-header>
            <v-expansion-panel-content v-for="k in deliveryaddress" :key="k">
              <v-row>
                <v-col md="1">
                  <v-checkbox v-model="delid" :value="k._id" @change="getProdt(delid)">
                    <strong>{{k.firstname}}</strong>
                  </v-checkbox>
                </v-col>
                <v-col md="1">
                  <h4 style="padding-top:20px;">
                    <strong>{{k.firstname}}</strong>
                  </h4>
                  {{k.locality}},{{k.streetAddress}}{{k.city.name}},{{k.district.name}},{{k.pincode}},{{k.state.name}},{{k.country}}
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>ADD A NEW ADDRESS</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-form ref="form">
                <v-row>
                  <v-col md="6">
                    <v-text-field
                      label="First Name"
                      type="text"
                      class="form-control"
                      id="productname"
                      v-model="firstname"
                      :rules="nameRules"
                      required
                    />
                  </v-col>
                  <v-col md="6">
                    <v-text-field
                      label="Last Name"
                      v-model="lastname"
                      type="text"
                      class="form-control"
                      id="productname"
                      :rules="namelRules"
                      required
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col md="6">
                    <v-text-field
                      label="Pincode"
                      v-model="pincode"
                      type="text"
                      class="form-control"
                      id="productname"
                      :rules="pinRules"
                      required
                    />
                  </v-col>
                  <v-col md="6">
                    <v-text-field
                      label="Locality"
                      v-model="locality"
                      type="text"
                      class="form-control"
                      id="productname"
                      :rules="locRules"
                      required
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <!-- <v-col md="3"></v-col> -->

                  <v-col md="6">
                   <v-text-field
                      v-model="streetAddress"
                      label="Street Address"
                      :rules="sRules"
                      hint="Hint text"
                    />
                  </v-col>
                  <v-col md="6">
                    <v-text-field
                      label="Country"
                      v-model="country"
                      type="text"
                      class="form-control"
                      id="productname"
                      :rules="cRules"
                      required
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col md="4">
                    <v-select
                      v-model="state"
                      :items="states"
                      label="State"
                      dense
                      :rules="stateRules"
                    ></v-select>
                  </v-col>
                  <v-col md="4">
                    <v-select
                      v-model="district"
                      :items="districts"
                      label="District"
                      dense
                      :rules="districtRules"
                    ></v-select>
                  </v-col>
                  <v-col md="4">
                    <v-select v-model="city" :items="cities" label="city" dense :rules="cityRules"></v-select>
                  </v-col>
                </v-row>
                <v-layout wrap justify-center>
                  <v-flex xs12 md12 pt-2 text-center>
                    <v-btn
                      rounded
                      :disabled="false"
                      width="500px"
                      class="text-capitalize hh"
                      dark
                      :ripple="false"
                      color="#26af82"
                      @click="reginit"
                    >SUBMIT</v-btn>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>
              <h3>
                <b>BILLING ADDRESS</b>
              </h3>
            </v-expansion-panel-header>
            <v-expansion-panel-content v-for="j in billingaddress" :key="j">
              <v-row>
                <v-col md="1">
                  <v-checkbox v-model="billid" :value="j._id">
                    <strong>{{j.firstname}}</strong>
                  </v-checkbox>
                </v-col>
                <v-col md="1">
                  <h4 style="padding-top:20px;">
                    <strong>{{j.firstname}}</strong>
                  </h4>
                  {{j.locality}},{{j.streetAddress}}{{j.city.name}},{{j.district.name}},{{j.pincode}},{{j.state.name}},{{j.country}}
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>ADD A NEW ADDRESS</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-form ref="form">
                <v-row>
                  <v-col md="6">
                    <v-text-field
                      label="First Name"
                      type="text"
                      class="form-control"
                      id="productname"
                      v-model="firstname"
                      :rules="nameRules"
                      required
                    />
                  </v-col>
                  <v-col md="6">
                    <v-text-field
                      label="Last Name"
                      v-model="lastname"
                      type="text"
                      class="form-control"
                      id="productname"
                      :rules="namelRules"
                      required
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col md="6">
                    <v-text-field
                      label="Pincode"
                      v-model="pincode"
                      type="text"
                      class="form-control"
                      id="productname"
                      :rules="pinRules"
                      required
                    />
                  </v-col>
                  <v-col md="6">
                    <v-text-field
                      label="Locality"
                      v-model="locality"
                      type="text"
                      class="form-control"
                      id="productname"
                      :rules="locRules"
                      required
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <!-- <v-col md="3"></v-col> -->

                  <v-col md="6">
                     <v-text-field
                      v-model="streetAddress"
                      label="Street Address"
                      :rules="sRules"
                      hint="Hint text"
                   />
                  </v-col>
                  <v-col md="6">
                    <v-text-field
                      label="Country"
                      v-model="country"
                      type="text"
                      class="form-control"
                      id="productname"
                      :rules="cRules"
                      required
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col md="4">
                    <v-select
                      v-model="state"
                      :items="states"
                      label="State"
                      dense
                      :rules="stateRules"
                    ></v-select>
                  </v-col>
                  <v-col md="4">
                    <v-select
                      v-model="district"
                      :items="districts"
                      label="District"
                      dense
                      :rules="districtRules"
                    ></v-select>
                  </v-col>
                  <v-col md="4">
                    <v-select v-model="city" :items="cities" label="city" dense :rules="cityRules"></v-select>
                  </v-col>
                </v-row>
                <v-layout wrap justify-center>
                  <v-flex xs12 md12 pt-2 text-center>
                    <v-btn
                      rounded
                      :disabled="false"
                      width="500px"
                      class="text-capitalize hh"
                      dark
                      :ripple="false"
                      color="#26af82"
                      @click="reginit"
                    >SUBMIT</v-btn>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
      <v-col md="4">
        <v-card>
          <v-card-title>Price Details</v-card-title>
          <v-row>
            <v-col md="6">
              <h3 style="padding-left:20px;">Price</h3>
            </v-col>
            <v-col md="6">
              <h3>{{total}}</h3>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6">
              <h3 style="padding-left:20px;">Shipping Charges</h3>
            </v-col>
            <v-col md="6">
              <h3>{{ship}}</h3>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6">
              <h3 style="padding-left:20px;">Total Tax</h3>
            </v-col>
            <v-col md="6">
              <h3>{{tottax}}</h3>
            </v-col>
          </v-row>
          <hr />
          <v-row>
            <v-col md="6">
              <h3 style="padding-left:20px;">Subtotal</h3>
            </v-col>
            <v-col md="6">
              <h3>{{subtotal}}</h3>
            </v-col>
            <v-row>
              <v-col md="6">
                <h3 style="padding-left:20px;">Payable Amount</h3>
              </v-col>
              <v-col md="6">
                <h3>{{final}}</h3>
              </v-col>
            </v-row>
            <v-col md="8" style="text-align:right;">
              <v-btn color="orange darken-2" dark @click="payment">Proceed to Pay</v-btn>
            </v-col>
          </v-row>

          <v-card-text></v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import store from "../../store";
import axios from "axios";
import { request } from "http";
export default {
  data() {
    return {
      // panel: [true, false, false, false],
      disabled: true,
      prodata: [],
      trip: {
        name: "",
        location: null,
        start: null,
        end: null
      },
      // panel:[0],
   
country:"",
pincode:"",
      locality: "",
      streetAddress: "",

      states: [],
      statesId: [],
      state: null,
      stateId: null,
      districts: [],
      districtsId: [],
      district: null,
      districtId: null,
      cities: [],
      citiesId: [],
      city: null,
      cityId: null,

      total: "",
      subtotal: "",
      tottax: "",
      userData: "",
      delid: "",
      billid: "",
      mobile: "",
      email: "",
      firstname: "",
      lastname: "",
      billingaddress: [],
      deliveryaddress: [],
      billId: "",
      ship: "",
      final: "",

      nameRules: [v => !!v || "Name is required"],
      namelRules: [v => !!v || " required"],
      locRules: [v => !!v || " required"],
      cRules: [v => !!v || "required"],
      sRules: [v => !!v || " required"],
      pinRules: [v => !!v || " required"],
      stateRules: [v => !!v || " required"],
      districtRules: [v => !!v || " required"],
      cityRules: [v => !!v || " required"],
      PayRules: [v => !!v || "  please choose delivery address required"]
    };
  },

  beforeMount() {
    this.stateList();
  },
  watch: {
    state: function() {
      this.districtList();
    },
    district: function() {
      this.cityList();
    }
  },
  mounted: function() {
    this.getProduct();
    this.getUser();
    this.getProdt();
   this. getproducts();
  },
  methods: {
    getproducts() {
      axios({
        method: "GET",
        url: "/product/info?id=" + this.id
      }).then(Response => {
        // console.log(Response);
        this.prodata = Response.data.data;
        this.photos = Response.data.data.photos;

        var tempflag = [];
        for (var i = 0; i < this.photos.length; i++) {
          var tyimg = {
            src: "https://api.inguzsales.in/u/" + this.photos[i],
            // src: $Image_URL + this.regions[i].flag,
            id: this.photos[i]
          };
          tempflag.push(tyimg);
        }
        this.dataImages = tempflag;
      });
    },
    minusCart(i) {
      for (var j = 0; j < this.prodata.length; j++) {
        if (i._id == this.prodata[j]._id) {
          this.prodata[j].quantity--;
        }
      }
      var data = {};
      data["productid"] = i.product._id;
      data["quantity"] = i.quantity;
      axios({
        method: "POST",
        url: "/Cart/update/",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          if (response.data.status == true) {
            this.getProduct();
            this.msg = response.data.msg;
            this.$dlg.alert(this.msg, () => {}, { messageType: "success" });
          } else {
            this.msg = response.data.msg;
            this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
          }
        })
        .catch(e => {
          this.msg = "Not Success";
          this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
        });
    },
    UpdateCart(i) {
      for (var j = 0; j < this.prodata.length; j++) {
        if (i._id == this.prodata[j]._id) {
          this.prodata[j].quantity++;
        }
      }
      var data = {};
      data["productid"] = i.product._id;
      data["quantity"] = i.quantity;
      axios({
        method: "POST",
        url: "/Cart/update/",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          if (response.data.status == true) {
            this.getProduct();
            this.msg = response.data.msg;
            this.$dlg.alert(
              this.msg,
              () => {
                window.location.reload();
              },
              { messageType: "success" }
            );
          } else {
            this.msg = response.data.msg;
            this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
          }
        })
        .catch(e => {
          this.msg = "Not Success";
          this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
        });
    },
    getProdt(delid) {
      axios({
        method: "GET",
        url: "/Cart/all/?deliveryaddressid=" + delid,

        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      }).then(Response => {
        this.prodata = Response.data.cart;
        this.total = Math.round(Response.data.total);
        this.subtotal = Math.round(Response.data.subtotal);
        this.tottax = Math.round(Response.data.totaltax);
        this.ship = Math.round(Response.data.shippingcharge);
        this.final = Math.round(Response.data.finalamount);
        // console.log(Response);
      });
    },
    payment() {
      var datas = {};

      datas["billingaddressindex"] = this.billid;
      datas["deliveryaddressindex"] = this.delid;
      datas["amount"] = this.final;

      datas["firstname"] = this.firstname;
      datas["lastname"] = this.lastname;
      datas["mobile"] = this.mobile;
      datas["email"] = this.email;

      // this.dialog = false;
      axios({
        method: "POST",
        url: "/payment/checkout/",
        data: datas,
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          // alert("then")
          if (response.data.status == false) {
            this.msg = response.data.msg;
            this.$dlg.alert(this.msg, () => {}, { messageType: "success" });
          }
          // if(response.data.status==false)
          // {
          //     alert(response.data.msg)
          // }
          else window.location = response.data.redirecturl;
        })
        .catch(e => {
          this.msg = "Not Success";
          this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
        });
    },
    getUser() {
      axios({
        method: "GET",
        url: "/user/profile/",

        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      }).then(response => {
        this.userData = response.data.data;
        this.mobile = response.data.data.phone;
        this.email = response.data.data.email;
        this.firstname = response.data.data.firstname;
        this.lastname = response.data.data.lastname;
        this.locality = response.data.data.locality;
        this.streetAddress = response.data.data.streetAddress;
        this.billingaddress = response.data.data.billingaddress;
        this.deliveryaddress = response.data.data.deliveryaddress;

        var tempid = [];
        for (var i = 0; i < this.billingaddress.length; i++) {
          var tyid = this.billingaddress[i]._id;
          temp.push(ty);
          tempid.push(tyid);
        }

        this.billid = tempid;

        this.deliveryaddress = response.data.data.deliveryaddress;

        var tempid = [];
        for (var i = 0; i < this.deliveryaddress.length; i++) {
          var tyid = this.deliveryaddress[i]._id;
          temp.push(ty);
          tempid.push(tyid);
        }

        this.delid = tempid;
        this.visible = false;
      });
    },
    getProduct() {
      axios({
        method: "GET",
        url: "/Cart/all/",

        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      }).then(Response => {
        this.prodata = Response.data.cart;
        this.total = Math.round(Response.data.total);
        this.subtotal = Math.round(Response.data.subtotal);
        this.tottax = Math.round(Response.data.totaltax);
        this.ship = Math.round(Response.data.shippingcharge);
        this.final = Math.round(Response.data.finalamount);
        // console.log(Response);
      });
    },

    stateList() {
      // this.dialog = false;

      axios({
        method: "GET",
        url: "/loc/StateList/"
      })
        .then(response => {
          this.states = response.data.data;
          var temp = [];
          var tempid = [];
          for (var i = 0; i < this.states.length; i++) {
            var ty = this.states[i].name;
            var tyid = this.states[i]._id;
            temp.push(ty);
            tempid.push(tyid);
          }
          this.states = temp;
          this.statesId = tempid;

          console.log(err);
        })
        .catch(err => {
          this.msg = "Something Went Wrong";
          // alert(err);
          // console.log(err);
        });
    },
    districtList() {
      this.visible = true;
      for (var j = 0; j < this.states.length; j++) {
        if (this.state == this.states[j]) {
          this.stateId = this.statesId[j];
        }
      }
      axios({
        method: "GET",
        url: "/loc/DistrictList/?stateid=" + this.stateId
      })
        .then(response => {
          // console.log("VehicleModel", response);
          this.districts = response.data.data;
          var temp = [];
          var tempid = [];
          for (var i = 0; i < this.districts.length; i++) {
            var ty = this.districts[i].name;
            var tyid = this.districts[i]._id;
            temp.push(ty);
            tempid.push(tyid);
          }
          this.districts = temp;
          this.districtsId = tempid;
          this.visible = false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    cityList() {
      this.visible = true;
      for (var j = 0; j < this.districts.length; j++) {
        if (this.district == this.districts[j]) {
          this.districtId = this.districtsId[j];
        }
      }
      axios({
        method: "GET",
        url: "/loc/CityList/?districtid=" + this.districtId
      })
        .then(response => {
          // console.log("VehicleModel", response);
          this.cities = response.data.data;
          var temp = [];
          var tempid = [];
          for (var i = 0; i < this.cities.length; i++) {
            var ty = this.cities[i].name;
            var tyid = this.cities[i]._id;
            temp.push(ty);
            tempid.push(tyid);
          }
          this.cities = temp;
          this.citiesId = tempid;
          this.visible = false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    billSubmit() {
      if (this.$refs.form.validate()) {
        if (this.state == null) {
          this.msg = "Please select state options";
          this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
          this.validateselection = false;
        }

        for (var j = 0; j < this.districts.length; j++) {
          if (this.district == this.districts[j]) {
            this.districtId = this.districtsId[j];
          }
        }
        if (this.district == null) {
          this.msg = "Please select district options";
          this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
          this.validateselection = false;
        }

        for (var j = 0; j < this.cities.length; j++) {
          if (this.city == this.cities[j]) {
            this.cityId = this.citiesId[j];
          }
        }

        var datas = {};
        datas["firstname"] = this.firstname;
        datas["lastname"] = this.lastname;
        datas["country"] = this.country;
        datas["state"] = this.stateId;
        datas["district"] = this.districtId;
        datas["pincode"] = this.pincode;
        datas["streetAddress"] = this.streetAddress;
        datas["locality"] = this.locality;
        datas["city"] = this.cityId;
        // this.dialog = false;
        axios({
          method: "POST",
          url: "/billingaddress/add/",
          data: datas,
          headers: {
            "x-auth-token": localStorage.getItem("token")
          }
        })
          .then(response => {
            if (response.data.status == true) {
              this.billid = response.data.id;
              this.msg = "successfully added";
              this.$dlg.alert(
                this.msg,
                () => {
                  window.location.reload();
                },
                { messageType: "success" }
              );
            } else {
              this.msg = response.data.msg;
              this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
            }
          })
          .catch(e => {
            this.msg = "Not Success";
            this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
          });
      }
    },

    reginit() {
      if (this.$refs.form.validate()) {
        if (this.state == null) {
          this.msg = "Please select state options";
          this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
          this.validateselection = false;
        }

        for (var j = 0; j < this.districts.length; j++) {
          if (this.district == this.districts[j]) {
            this.districtId = this.districtsId[j];
          }
        }
        if (this.district == null) {
          this.msg = "Please select district options";
          this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
          this.validateselection = false;
        }

        for (var j = 0; j < this.cities.length; j++) {
          if (this.city == this.cities[j]) {
            this.cityId = this.citiesId[j];
          }
        }

        var datas = {};
        datas["firstname"] = this.firstname;
        datas["lastname"] = this.lastname;
        datas["country"] = this.country;
        datas["state"] = this.stateId;
        datas["district"] = this.districtId;
        datas["pincode"] = this.pincode;
        datas["streetAddress"] = this.streetAddress;
        datas["locality"] = this.locality;
        datas["city"] = this.cityId;
        // this.dialog = false;
        axios({
          method: "POST",
          url: "/deliveryaddress/add/",
          data: datas,
          headers: {
            "x-auth-token": localStorage.getItem("token")
          }
        })
          .then(response => {
            if (response.data.status == true) {
              this.delid = response.data.id;

              this.msg = "successfully added";
              this.$dlg.alert(
                this.msg,
                () => {
                  window.location.reload();
                },
                { messageType: "success" }
              );
            } else {
              this.msg = response.data.msg;
              this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
            }
          })
          .catch(e => {
            this.msg = "Not Success";
            this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
          });
      }
    }
  }
};
</script>
<style scoped>
.hh {
  background-color: #ff4e00;
  background-image: linear-gradient(315deg, #ff4e00 0%, #ec9f05 74%);
}
.by {
  width: 28px;
  height: 28px;
  background: linear-gradient(#fff, #f9f9f9);
  display: inline-block;
  border: 1px solid #c2c2c2;
  cursor: pointer;
  font-size: 16px;
  border-radius: 50%;
  padding-top: 1px;
  line-height: 1;
}
.bu {
  width: 28px;
  height: 28px;
  background: linear-gradient(#fff, #f9f9f9);
  display: inline-block;
  border: 1px solid #c2c2c2;
  cursor: pointer;
  font-size: 16px;

  padding-top: 1px;
  line-height: 1;
}
.jj {
  height: 146px;
  width: 143px;
}
</style>
